import React, { useState, useEffect } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { Users } from "lucide-react";
import { GroupToAccount } from "./GroupToAccount";
import { AccountToGroup } from "./AccountToGroup";
import { useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { useSelector } from "react-redux";
import { FiMenu } from "react-icons/fi";
import { useTheme } from "../../../Themecontext/Themecontext";



export const PartyProfile = () => {
  const location = useLocation();
  const [activeView, setActiveView] = useState("group");

  useEffect(() => {
    if (location.state?.searchParty) {
      setActiveView("account");
    }
  }, [location.state]);

  const { Colourdata } = useSelector((state) => state.ClientLogin);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "GRAYNEW");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "GRAYDARKNEW"
  );

  const { theme } = useTheme();
  const isdark = theme;


  const [showFilter, setShowFilter] = useState(false);

  const handleShow = () => setShowFilter(true);
  const handleClose = () => setShowFilter(false);

  return (
    <div className="mt-3 pageContainer">

      {/* Header */}
      <Row>
        <Col>
          <div className="d-lg-none text-end">
            <Button
              onClick={handleShow}
              style={{
                border: "none",
                backgroundColor:
                  isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
                color:
                  isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8,
              }}
            >
              <FiMenu size={22} />
            </Button>
          </div>
        </Col>

      </Row>

      {/* Buttons */}

      <Row className="mt-4 g-3 justify-content-center">

        <Col sm={12} md={4} lg={3}>
          <Button
            onClick={() => setActiveView("group")}
            className="hover-scale-btn"
            style={{
              width: "100%",
              background: activeView === "group"
                ? isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour9
                : isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour6,
              color: activeView === "group" ? isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour2 : isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
              border:
                activeView === "group"
                  ? `2px solid ${isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour9
                  }`
                  : `2px solid ${isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour3
                  }`,
              borderRadius: "12px",
              padding: "12px",
              fontWeight: "700"
            }}
          >
            GROUP TO PARTY VIEW
          </Button>
        </Col>

        <Col sm={12} md={4} lg={3}>
          <Button
            className="hover-scale-btn"
            onClick={() => setActiveView("account")}
            style={{
              width: "100%",
              background: activeView === "account"
                ? isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour9
                : isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour6,
              color: activeView === "account" ? isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour2 : isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
              border:
                activeView === "account"
                  ? `2px solid ${isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour9
                  }`
                  : `2px solid ${isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour3
                  }`,
              borderRadius: "12px",
              padding: "12px",
              fontWeight: "700"
            }}
          >
            PARTY TO GROUP VIEW
          </Button>
        </Col>



      </Row>

      {/* Dynamic Content */}

      <Row className="mt-4">
        <Col>

          {activeView === "group" && <GroupToAccount
            showFilter={showFilter}
            handleClose={handleClose}
          />}
          {activeView === "account" && <AccountToGroup
            showFilter={showFilter}
            handleClose={handleClose}
          />}
        </Col>

      </Row>

    </div>
  );
};